import { render, staticRenderFns } from "./group-slot.mpx?vue&type=template&id=22c5581a&isComponent&outputPath=components%2Fgroup-slot14234ad1%2Findex"
import script from "./group-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fgroup-slot14234ad1%2Findex"
export * from "./group-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fgroup-slot14234ad1%2Findex"
import style0 from "./group-slot.mpx?vue&type=style&index=0&id=22c5581a&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_14234ad1%22%7D&isComponent&outputPath=components%2Fgroup-slot14234ad1%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports